import type { TrainingFollowUpTrainingItemVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const adminRetrieveTrainingItems = createApiThunk<TrainingFollowUpTrainingItemVM[], string>(
  "trainingFollowUps/adminRetrieveTrainingItems",
  async (trainingFollowUpId: string, { extra: { adminRepository } }) => {
    return adminRepository!.getTrainingItems(trainingFollowUpId);
  },
);
